(function () {
    "use strict";/********************************************************************************************************/
    /**** @CC CLIENT_SPECIFIC_CUSTOMIZATION - START
     /**** - this is where functions that add new functionality which don't override default rendering engine functions go
     /****
     /**** below is an example of how you add new functionallity. noting the following:
     /**** 	-> the 'cip_Custom' object name needs to be used for all new properties and functions
     /****
     /**** 	cip_Custom.lastGetQuestionsTask = null;
     /****
     /**** 	cip_Custom.getLastQuestionInSection = function(pageId, sectionName){
	/**** 		var lastQuestionInSection = null;
	/****
	/**** 		$.each($("#" + cc_View.getSectionDivId(pageId, sectionName) + " .questionPanel:visible"), function(){
	/**** 			var questionId = $(this).attr('cc-panel');
	/****
	/**** 			if(cc_Model.anyLevelQuestionMap[questionId].type.value != "type-less"){
	/**** 				lastQuestionInSection = cc_Model.anyLevelQuestionMap[questionId];
	/**** 			}
	/**** 		});
	/****
	/**** 		return lastQuestionInSection;
	/**** 	};
     /********************************************************************************************************/

    cip_Custom.clientContinueLaterPage_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-continue-later ";
// cip_Custom.clientSubmitPage_PersonalLoan_Url = "https://www.regionalaustraliabank.com.au/personal/products/thanks-for-applying---pl";
// cip_Custom.clientSubmitPage_PersonalLoan_202_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-202-pl";
// cip_Custom.clientSubmitPage_PersonalLoan_203_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-203-pl";
// cip_Custom.clientSubmitPage_PersonalLoan_403_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-403-pl";

// cip_Custom.clientSubmitPage_CreditCard_Url = "https://www.regionalaustraliabank.com.au/personal/products/thanks-for-applying---cc";
// cip_Custom.clientSubmitPage_CreditCard_202_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-202-cc";
// cip_Custom.clientSubmitPage_CreditCard_203_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-203-cc";
// cip_Custom.clientSubmitPage_CreditCard_403_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-403-cc";

    cip_Custom.clientSubmitPage_PersonalCredit_202_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-202-pl";

    cip_Custom.clientSubmitPage_Mortgage_202_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-202-hl-202001";

    cip_Custom.clientSubmitPage_Hardship = "https://www.regionalaustraliabank.com.au/Thank-You/Apply-Financial-hardship-assistance";

    cip_Custom.clientContinueLaterPage_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-continue-later ";
// cip_Custom.clientSubmitPage_PersonalLoan_Url = "https://www.regionalaustraliabank.com.au/personal/products/thanks-for-applying---pl";
// cip_Custom.clientSubmitPage_PersonalLoan_202_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-202-pl";
// cip_Custom.clientSubmitPage_PersonalLoan_203_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-203-pl";
// cip_Custom.clientSubmitPage_PersonalLoan_403_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-403-pl";

// cip_Custom.clientSubmitPage_CreditCard_Url = "https://www.regionalaustraliabank.com.au/personal/products/thanks-for-applying---cc";
// cip_Custom.clientSubmitPage_CreditCard_202_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-202-cc";
// cip_Custom.clientSubmitPage_CreditCard_203_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-203-cc";
// cip_Custom.clientSubmitPage_CreditCard_403_Url = "http://www.regionalaustraliabank.com.au/thank-you/apply-403-cc";

    cip_Custom.clientSubmitPage_PersonalCredit_202_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-202-pl";

    cip_Custom.clientSubmitPage_Mortgage_202_Url = "https://www.regionalaustraliabank.com.au/thank-you/apply-202-hl-202001";

    cip_Custom.clientSubmitPage_Hardship = "https://www.regionalaustraliabank.com.au/Thank-You/Apply-Financial-hardship-assistance";

// @CC Copied From: cc_Config.enableLazyQuestionRendering @ v12_1
    cc_Config.enableLazyQuestionRendering = true;

// @CC Copied From: cc_Controller.save() @ v12_1
    cc_Controller.save = function (triggerType, manuallySelectedPageId, triggeringQuestionId, onQuestionsResponse, isLastNonRestrictedPageSelected) {
        // triggerType are: "PAGE_SELECTION", "SHOW_RESULTS", "QUESTION_TRIGGER", "ADD_DOCUMENT", "REMOVE_DOCUMENT, "NEXT", "PREVIOUS", "SAVE"

        var isUserDriven = triggerType == "PAGE_SELECTION" || triggerType == "NEXT" || triggerType == "PREVIOUS" || triggerType == "SAVE" || triggerType == "SHOW_RESULTS";
        var isExplictSave = triggerType === "SAVE" || triggerType === "NEXT";
        var enableMoveToRelativePage = triggerType == "NEXT" || triggerType == "PREVIOUS";
        var includeAdvancedInformation = triggerType == "SHOW_RESULTS";

        var isLastNonRestrictedPageSelectedOnSave = cc_Model.isLastNonRestrictedPageSelected;
        var isWritableRestrictedPageSelected = cc_Model.isWritableRestrictedPageSelected;

        var task = {
            triggerType : triggerType,
            manuallySelectedPageId : manuallySelectedPageId,
            enableMoveToRelativePage : enableMoveToRelativePage,
            isUserDriven : isUserDriven,
            isExplictSave : isExplictSave,
            triggeringQuestionId : triggeringQuestionId,
            focusedQuestionId : cc_UI.getFocusedQuestionId(),
            includeAdvancedInformation : includeAdvancedInformation,
        };

        // Cache override for CDR refresh
        if (triggeringQuestionId === "ApplicantLivingExpenseCDRRefresh") {
            task.isCDRPollingRequest = true;
        }

        if(cc_Renderer.hasFilesToUpload() === true){
            cc_UI.showWarningDialog("Please ensure you have uploaded all documents.", "Need to Upload Document");

        }else{
            // proactively select the page to give the user immediate feedback
            if(triggerType == "PAGE_SELECTION"){
                cc_Renderer.selectPageNavigatorItem(manuallySelectedPageId);
            }

            // if there are previous findings, then findings should be regenerated each time.
            // this way there isnt the situation where answers are changed but the findings are not regenderated
            cc_Controller.getQuestions(cc_Model.isInterviewComplete, task, function(result){
                if(result.isReadyToFinish == true){
                    if(cc_Model.isInterviewInProgress() === true){

                        // only perform the following logic when the submit / generate findings button has been pressed
                        if(cc_Controller.hasUserRequestedSubmission(result.triggerType, result.isReadyToFinish, cc_Model.isInterviewComplete, isLastNonRestrictedPageSelectedOnSave, isWritableRestrictedPageSelected) === true){
                            cc_EntityIntegration.onPreFindingsAssessment(function(){
                                return cc_Controller.getQuestions(true, null, function(result){
                                    cc_Controller.handleSubmissionResult(result, function(){
                                        cc_EntityIntegration.onPostFindingsAssessment();
                                    });
                                });
                            });
                        }

                    }else if(result.hasRegeneratedFindings === true && isExplictSave == true){
                        // only trigger this event when it is an explicit save otherwise it can become very annoying
                        cc_EntityIntegration.onPostFindingsReassessment();
                    }
                }

                if(onQuestionsResponse){
                    onQuestionsResponse();
                }
            });
        }
    };

// @CC Copied From: cc_Ajax.defaults @ v12_1
    cc_Ajax.communityOverride = {
        timeout: cc_Ajax.defaultTimeout,
        cache: false,
        throbber: true,
        useShortThrobberKey: false,
        throbberDelay: 800,
        throbberMinimumOpen: 1000,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        error: function (jqXHR, textStatus, errorThrown){
            // don't show error if we're navigating away
            $.doTimeout(1000, function(){
                var message = null;

                if (jqXHR.status === 0) {
                    message = 'Cannot connect to server. Please ensure there is network connectivity then refresh page.';
                } else if (jqXHR.status == 404) {
                    message = 'Requested resource not found. Please refresh page and try again';
                } else if (jqXHR.status == 500) {
                    message = 'An internal server error has occured. Please refresh page and try again';
                } else if (jqXHR.status == 503) {
                    message = 'Service temporarily unavailable. Please refresh page and try again';
                } else {
                    message = 'Oops, it looks like something went wrong, please click Ok to continue with your application or call us on 132 067 if you need our help.';
                }

                if(message){
                    cc_UI.showErrorDialog(message, 'Error');
                }
            });
        },
        dataFilter : function (data, dataType) {
            if (dataType == "json" && data) {
                var json = JSON.parse(data);

                cc_Ajax.lastJsonResponse = json;

                // used by selenium to determine when a request is complete
                cc_Ajax.lastJsonResponseKey = cc_Util.generateRandomKey();

                if(data.indexOf("redirect") != -1 && json.redirect){
                    // data.redirect contains the string URL to redirect to
                    window.location.href = json.redirect;

                    // update the data so that the success handler knows to ignore it.
                    // please note that 'data = null' is not allowed in jquery 3.
                    data = {"redirecting" : true};
                }
            }

            return data;
        },
        beforeSend: function(jqXHR, settings){
            cc_Ajax.attachCSRF(jqXHR);

            if(settings.throbber === true){
                cc_Throbber.show(settings);
            }
        },
        success: function (data, statusText, jqXHR) {
            if(data){
                if (data.redirecting === true){
                    return; // do nothing to ensure handler isnt executed

                }else if (data.error){
                    cc_Ajax.lastJsonError = data;

                    var errorText = data.error;

//					var errorText = null;
//					if(data.isJsonRequest && data.isJsonRequest === true){
//						errorText = data.error;
//					}else{
//						errorText = cc_Util.decodeText(data.error);
//					}

                    var width = null;
                    if(data.cause == "SchemaValidationException" || data.cause == "RhinoScriptingException" ||
                        data.cause == "SpelExpressionException" || data.cause == "DSLParsingException" ||
                        data.cause == "RulesEngineException"){
                        width = 1080;
                    }

                    cc_UI.showErrorDialog(errorText, data.title, width);

                }else if(this.handle){
                    this.handle(data);
                }
            }
        },
        complete: function(){
            if(this.queued && this.queued === true){
                cc_Util.log('cc_Ajax.queue.next(): ' + this.key);

                // updated the last queue response so it can be used by the queue cache
                cc_Ajax.lastQueuedResponse = cc_Ajax.lastJsonResponse;

                cc_Ajax.queue.next();
            }

            // RIANF - patached back from v13_0 - start
            if(this.throbber === true){
                cc_Throbber.hide(this); // close the throbber if there is one
            }
            // RIANF - patached back from v13_0 - end
        }
    };
    $.ajaxSetup(cc_Ajax.communityOverride);

    window.addEventListener('resize', function(event){
        cc_UI.selectAccordionPage(cc_Model.getSelectedPageId());
    });
    window.addEventListener('orientationchange', function(event){
        cc_UI.selectAccordionPage(cc_Model.getSelectedPageId());
    });

    cip_Custom.currentTabBarActive = "";

    cip_Custom.renderTabBarContents = function() {
        function generateTabBarContents(page, isActive) {
            if (!page.visible || page.restricted) {
                return "";
            }

            var pageHierarchy = page.text.split("|");
            var pageText = pageHierarchy[0];
            var subpageText = pageHierarchy[1];

            var doesSubpageExist = !(subpageText === undefined || subpageText === "");

            var text = doesSubpageExist ? subpageText.trim() : pageText;

            var activeClass = isActive ? "selected" : "";

            return '<li page-id="'+ page.id +'" class="tab '+ activeClass +'">'+ text +'</li>';
        }

        var currentPages = cip_Custom.paginatePages(cc_Model.sortedTopLevelPages);
        var activePageId = cc_Model.getSelectedPageId();

        var $tabBarParent = $(".nav-tabs");
        var tabBarContentsHtml = "<li class='tab'></li>";

        // We only want to process an update on page change not after question update
        if (activePageId == cip_Custom.currentTabBarActive) {
            return;
        }

        cip_Custom.currentTabBarActive = activePageId;

        currentPages.forEach(function(page) {
            var selected = false;
            if (Array.isArray(page)) {

                page.map(function(currentPage) {
                    if (currentPage.id === activePageId) {
                        selected = true;
                    }
                });

                page = page[0];
            } else {
                selected = page.id === activePageId;
            }

            tabBarContentsHtml += generateTabBarContents(page, selected);
        });

        tabBarContentsHtml += "<li class='tab'></li>";


        $tabBarParent.html(tabBarContentsHtml);

        cip_Custom.centreActiveTabBar();
    }

    cip_Custom.centreActiveTabBar = function() {
        var $activeTab  = $('.tab.selected');
        var $tabBarParent = $(".nav-tabs");

        var x = $tabBarParent.width();
        var y = $activeTab.outerWidth(true);
        var z = $activeTab.index();

        $tabBarParent.scrollLeft(Math.max(0, (y * z) - (x - y)/2));
    }

    cip_Custom.getPageNavigatorItemSelector = function (pageId) {
        return '.page_navigator_item[cc-page-id=' + cc_Util.toWebSafeId(pageId) + ']';
    };

    cip_Custom.createChevronIcon = function() {
        return '<i class="chevron icon-rab-chevron-down-lime"></i>';
    }

    cip_Custom.unrenderNestedPages = function(navigator) {
        var nestedPages = navigator.find("ul");
        // remove the subpage parents
        nestedPages.find("li.subpageParent").remove();
        // unnest subpages
        nestedPages.find("li").unwrap();
    };

    cip_Custom.determinePageHierarchy = function(page) {
        var pageHierarchy = page.text.split("|");
        return {
            page: pageHierarchy[0] ? pageHierarchy[0].trim() : undefined,
            subpage: pageHierarchy[1] ? pageHierarchy[1].trim() : undefined,
            pagination: pageHierarchy[2] ? pageHierarchy[2].trim() : undefined,
        };
    };

    cip_Custom.nestPages = function(topLevelPages) {
        return topLevelPages
            .reduce(function(acc, page) {
                var pageHierarchy = cip_Custom.determinePageHierarchy(page);
                if (pageHierarchy.subpage) {
                    var previousPage = acc[acc.length-1];
                    var previousPageHierarchy = (previousPage && Array.isArray(previousPage)) ? cip_Custom.determinePageHierarchy(previousPage[0]) : undefined;
                    if (previousPageHierarchy && previousPageHierarchy.page === pageHierarchy.page) {
                        // If subpage exists,
                        // and if there is a previous page to compare to,
                        // and if the previous page is an array, representing a subpage grouping,
                        // and if the subpage prefixes match the current page prefix
                        previousPage.push(page);
                    } else {
                        acc.push([page]);
                    }
                } else {
                    acc.push(page);
                }
                return acc;
            }, []);
    };

    cip_Custom.createSubpageParentNavigatorItem = function(subpages) {

        function isASubpageSelected(subpageDOM) {
            return $(subpageDOM).filter(".selected").length !== 0;
        }
        function doesASubpageHaveError(subpageDOM) {
            return $(subpageDOM).find("i.errorIcon").length !== 0;
        }
        function doesASubpageHaveWarning(subpageDOM) {
            return $(subpageDOM).find("i.warningIcon").length !== 0;
        }
        function areAllsubpagesCompleted(subpageDOM) {
            return $(subpageDOM).find("i.completedIcon").length === $(subpageDOM).length;
        }

        function isASubPageSelected(subpageDOM) {
            return $(subpageDOM).hasClass("selected");
        }
        function collapseSubpages(subpageParentDOM, subpageDOM) {
            subpageParentDOM.removeClass("expanded");
            subpageDOM.hide();
            // // If all subpages are collapsed, open the 'show more' section automatically
            // if (subpageParentDOM.parent().find(".subpageParent").filter('.expanded').length === 0) {
            //     subpageParentDOM.parent().siblings('.showMore').click();
            // }
        }
        function expandSubpages(subpageParentDOM, subpageDOM) {
            subpageParentDOM.addClass("expanded");
            subpageDOM.show();
            // Collapse the 'show more' section of the page navigator
            subpageParentDOM.parent().siblings('.showLess').click();
        }

        var subpageDOM = $(
            subpages
                .map(function(subpage) {
                    return cip_Custom.getPageNavigatorItemSelector(subpage.id);
                })
                .join(",")
        );
        var prefix = cip_Custom.determinePageHierarchy(subpages[0]).page;
        var navigatorItemId = cc_View.getPageNavigatorItemId(prefix);
        var icon = doesASubpageHaveError(subpageDOM) ? cc_View.createErrorIcon(navigatorItemId) :
            doesASubpageHaveWarning(subpageDOM) ? cc_View.createWarningIcon(navigatorItemId) :
                areAllsubpagesCompleted(subpageDOM) ? cc_View.createAccentedCompletedIcon(navigatorItemId) :
                    isASubPageSelected(subpageDOM) ? '<i class="icon activeEditIcon" style=""></i>':
                        '<i class="icon placeholderIcon" style=""></i>';

        var subpageParentDOM = $(
            '<li id="' + navigatorItemId + '" class="page_navigator_item subpageParent" cc-page-id="' + prefix + '">' +
            '<a id="' + prefix + '_link">' +
            prefix +
            '</a>' +
            icon +
            cip_Custom.createChevronIcon() +
            '</li>'
        );

        if (areAllsubpagesCompleted(subpageDOM)) {
            subpageParentDOM.addClass('completed');
        }

        if (isASubpageSelected(subpageDOM)) {
            expandSubpages(subpageParentDOM, subpageDOM);
        } else {
            collapseSubpages(subpageParentDOM, subpageDOM);
        }

        $(subpageParentDOM).on("click", function() {
            if ($(subpageParentDOM).hasClass("expanded")) {
                collapseSubpages(subpageParentDOM, subpageDOM);
            } else {
                // Collapse all other subpages before opening this one
                $('[id=cloudcase-page-navigator-unrestricted]').find('ul').each(function(index, subpages) {
                    var subpageParentDOM = $(subpages).find('li').filter(':first');
                    var subpageDOM = $(subpages).find('li').not(':first');
                    collapseSubpages(subpageParentDOM, subpageDOM);
                })
                expandSubpages(subpageParentDOM, subpageDOM);
            }
        });

        return subpageParentDOM;
    };

    cip_Custom.renderNestedPages = function(nestedPages) {
        nestedPages
            .filter(function(page) {
                return Array.isArray(page);
            })
            .forEach(function(subpages) {
                // Desktop
                var subpageDOMDesktop = $(
                    subpages
                        .map(function(subpage) {
                            return ".desktop " + cip_Custom.getPageNavigatorItemSelector(subpage.id);
                        })
                        .join(",")
                );
                subpageDOMDesktop.wrapAll("<ul>");
                var subpageParentDOMDesktop = cip_Custom.createSubpageParentNavigatorItem(subpages);
                subpageDOMDesktop.parent().prepend(subpageParentDOMDesktop);

                // Mobile
                var subpageDOM = $(
                    subpages
                        .map(function(subpage) {
                            return ".mobile " + cip_Custom.getPageNavigatorItemSelector(subpage.id);
                        })
                        .join(",")
                );
                subpageDOM.wrapAll("<ul>");
                var subpageParentDOM = cip_Custom.createSubpageParentNavigatorItem(subpages);
                subpageDOM.parent().prepend(subpageParentDOM);
            });
    };

    cip_Custom.showNavigationOverlay = function() {
        cip_Custom.removeBodyScroll();
        $('.mobile-nav-overlay').addClass('active');
    }

    cip_Custom.hideNavigationOverlay = function() {
        cip_Custom.restoreBodyScroll();
        $('.mobile-nav-overlay').removeClass('active');
    }

    cip_Custom.removeBodyScroll = function() {
        // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
        // When the modal is shown, we want a fixed body
        document.body.style.position = 'fixed';
        document.body.style.width = '100vw';
        document.body.style.top = "-"+ window.scrollY +"px";
    }

    cip_Custom.restoreBodyScroll = function() {
        // https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
        var scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    cip_Custom.addCollapsibleNavigation = function() {
        var pages = cc_Model.sortedTopLevelPages.filter(function(page) {
            return page.visible;
        });
        var navigator = $("[id=cloudcase-page-navigator-unrestricted]");
        cip_Custom.unrenderNestedPages(navigator);
        var nestedPages = cip_Custom.nestPages(pages);
        cip_Custom.renderNestedPages(nestedPages);

    };

    cip_Custom.paginatePages = function(topLevelPages) {
        return topLevelPages
            .reduce(function(acc, page) {
                var pageHierarchy = cip_Custom.determinePageHierarchy(page);
                if (pageHierarchy.pagination) {
                    var previousPage = acc[acc.length-1];
                    var previousPageHierarchy = (previousPage && Array.isArray(previousPage)) ? cip_Custom.determinePageHierarchy(previousPage[0]) : undefined;
                    if (
                        previousPageHierarchy
                        && (
                            previousPageHierarchy.page === pageHierarchy.page
                            && previousPageHierarchy.subpage === pageHierarchy.subpage
                        )
                    ) {
                        // If pagination exists
                        // and if there is a previous page to compare to,
                        // and if the previous page is an array, representing a pagination grouping,
                        // and if the prefixes and subpages match
                        previousPage.push(page);
                    } else {
                        acc.push([page]);
                    }
                } else {
                    acc.push(page);
                }
                return acc;
            }, []);
    };

    cip_Custom.applyPagination = function(paginatedPages) {
        paginatedPages
            .filter(function(page) {
                return Array.isArray(page);
            })
            .forEach(function(paginations) {
                var paginationDOM = $(
                    paginations
                        .map(function(pagination) {
                            return cip_Custom.getPageNavigatorItemSelector(pagination.id);
                        })
                        .join(",")
                );
                // Hide all except the first
                paginationDOM.filter(cip_Custom.getPageNavigatorItemSelector(paginations[0].id)).addClass("paginated-show");
                paginationDOM.not(cip_Custom.getPageNavigatorItemSelector(paginations[0].id)).addClass("paginated-hide");
            });
    };

    cip_Custom.addPaginatedNavigation = function() {
        var pages = cc_Model.sortedTopLevelPages.filter(function(page) {
            return page.visible;
        });
        var paginatedPages = cip_Custom.paginatePages(pages);
        cip_Custom.applyPagination(paginatedPages);
    };

    cip_Custom.addPaginationToPage = function(page) {
        var pageHierarchy = cip_Custom.determinePageHierarchy(page);
        if (pageHierarchy.pagination) {
            return '' +
                '<div class="page-pagination">' +
                '<span>' + pageHierarchy.pagination + '</span>' +
                '</div>';
        } else {
            return '';
        }
    };

    cip_Custom.getPaginationSectionsClass = function(page) {
        var pageHierarchy = cip_Custom.determinePageHierarchy(page);
        if (pageHierarchy.pagination) {
            return 'has-pagination';
        } else {
            return '';
        }
    };

    cip_Custom.selectPagePagination = function(pageId) {
        $(".page-pagination").hide();
        $("#" + cc_View.getPageDivId(pageId) + " .page-pagination").show();
    };

// cip_Custom.showMore = function() {
//     function createShowMore() {
//         var html = $(
//             '<li class="page_navigator_item showMore">' +
//             '<a>Show more...</a>' +
//             '<i class="icon icon-rab-plus-invert"></i>' +
//             '</li>');
//
//         html.on('click', function() {
//             collapsiblePagesDOM.show();
//             $('.page_navigator_item.showMore').hide();
//             $('.page_navigator_item.showLess').show();
//         });
//
//         return html;
//     }
//
//     function createShowLess() {
//         var html = $(
//             '<li class="page_navigator_item showLess">' +
//             '<a>Show less...</a>' +
//             '<i class="icon icon-rab-minus-invert"></i>' +
//             '</li>');
//
//         html.on('click', function() {
//             collapsiblePagesDOM.hide();
//             $('.page_navigator_item.showMore').show();
//             $('.page_navigator_item.showLess').hide();
//         });
//
//         return html;
//     }
//
//     var collapsiblePages = [
//         "Assets",
//         "Income",
//         "Liability",
//         "LivingExpenses",
//         "DepositSecurity",
//         "Guarantors",
//         "Evidence",
//         "Summary"
//     ];
//     var collapsiblePagesDOM = $(
//         collapsiblePages
//             .map(function(page) {
//                 return cip_Custom.getPageNavigatorItemSelector(page)
//             })
//             .join(",")
//     );
//     $('.page_navigator_item.showLess,.page_navigator_item.showMore').remove();
//     var showMore = createShowMore();
//     var showLess = createShowLess();
//     collapsiblePagesDOM.filter(cip_Custom.getPageNavigatorItemSelector(collapsiblePages[collapsiblePages.length-1])).after(showLess);
//     collapsiblePagesDOM.filter(cip_Custom.getPageNavigatorItemSelector(collapsiblePages[collapsiblePages.length-1])).after(showMore);
//
//     // If all subpages are collapsed, open the 'show more' section automatically
//
//     if (showLess.siblings().find(".subpageParent").filter('.expanded').length === 0) {
//         showMore.click();
//     } else {
//         showLess.click();
//     }
// };

    cip_Custom.attachCurrentPageSelector = function() {
        var $selectedNavElement = $(".page_navigator_item.selected");

        var isSubpage = $selectedNavElement.hasClass("subpage");

        var $targetIElement = $selectedNavElement.children('.icon-rab-');

        if ($targetIElement.length > 0) {
            $targetIElement.removeClass('icon-rab-');
            if (isSubpage) {
                $targetIElement.addClass('icon-rab-arrow-right-blue')

                // find parent and replace default with selected
                $targetIElement.parent().parent().children().first().children('.icon-rab-arrow-right-blue').removeClass('icon-rab-arrow-right-blue').addClass('icon-rab-arrow-right-white');
            } else {
                $targetIElement.addClass('icon-rab-arrow-right-white')
            }
        }
    }

    cip_Custom.doesQuestionRequireFeatureText = function(question) {
        if (question && question.properties) {
            for (var i = 0; i < question.properties.length; i++) {
                if (question.properties[i].id === "FeatureText" && question.properties[i].value === "true") {
                    return true;
                }
            }
        }

        return false;
    }

    cip_Custom.createNextButtonTextFromEventBridge = function(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad){
        var text = null;
        // CUSTOMISED SECTION --- Event Bridge
        var eventBridge = null;

        if (window.hasOwnProperty("vueJSWidget") && vueJSWidget.initialisedWidgetsMap["UIEventBridge"]) {
            eventBridge = vueJSWidget.initialisedWidgetsMap["UIEventBridge"].vue;
        }

        if (eventBridge && !eventBridge.isNextVisible(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad)) {
            return null;
        } else if (eventBridge) {
            return eventBridge.nextButtonText(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad);
        }

        return "Continue";
        // End CUSTOMISED SECTION --- Event Bridge
    };

    cip_Custom.createPreviousButtonTextFromEventBridge = function(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad){
        var text = null;

        // CUSTOMISED SECTION --- Event Bridge
        var eventBridge = null;

        if (window.hasOwnProperty("vueJSWidget") && vueJSWidget.initialisedWidgetsMap["UIEventBridge"]) {
            eventBridge = vueJSWidget.initialisedWidgetsMap["UIEventBridge"].vue;
        }

        if (eventBridge && !eventBridge.isBackVisible(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad)) {
            return null;
        } else if (eventBridge) {
            return eventBridge.backButtonText(isFirstPageSelected, isLastNonRestrictedPageSelected, isReadyToFinish, isInterviewComplete, treatInterviewAsCompletedOnLoad);
        }
        // End CUSTOMISED SECTION --- Event Bridge

        if(isFirstPageSelected == false){
            text = 'Previous';
        }

        return text;
    };

    cip_Custom.getCustomGridColumns = function (question) {
        var columns = cc_Model.getProperty("GridColumns", question)
        return columns ? "grid-columns-" + columns + " " : "";
    };
})();